import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const AbstractDropdownContext = /*#__PURE__*/createContext(undefined);
export const AbstractDropdownProvider = ({
  buttonStyleOverrides = {},
  children
}) => {
  const value = useMemo(() => ({
    buttonStyleOverrides
  }), [buttonStyleOverrides]);
  return /*#__PURE__*/_jsx(AbstractDropdownContext.Provider, {
    value: value,
    children: children
  });
};

/**
 * Provides the context for the `AbstractDropdown` component.
 * Note: The context is only available when the `AbstractDropdown` component is rendered as an ancestor.
 * @returns AbstractDropdownContext - The context for the `AbstractDropdown` component.
 * @returns AbstractDropdownContext.buttonStyleOverrides - Style overrides to be applied to the `Button` component.
 */
export const useAbstractDropdownContext = () => {
  const abstractDropdownContext = useContext(AbstractDropdownContext);
  return abstractDropdownContext;
};